import React from "react"
import { TRUST_AND_SECURITY_URL } from "constants/urls"
import Button from "components/ui/Button"
import CircleCheckList, { ListItem } from "components/ui/CircleCheckList"
import Container from "components/ui/Container"
import Heading from "components/ui/Heading"

function DataAndCloudSecuritySection() {
  return (
    <Container>
      <Heading
        label="Data and Cloud Security"
        title="How Preset handles data security and compliance"
        decoration="border"
      />
      <CircleCheckList className="mt-12">
        <ListItem>
          Preset Cloud is certified as SOC2 Type 2, PCI-DSS compliant
        </ListItem>
        <ListItem>Encryption for data in transit with TLS 1.3+</ListItem>
        <ListItem>
          Role-Based Access Controls (RBAC) for fine-grained permissions
        </ListItem>
        <ListItem>
          Encryption for data at rest with AES 256 encrypted storage
        </ListItem>
        <ListItem>Multi-factor authentication (MFA)</ListItem>
        <ListItem>Secure software development lifecycle (SDLC)</ListItem>
      </CircleCheckList>
      <Button
        className="mt-12"
        color="green"
        size="medium"
        href={TRUST_AND_SECURITY_URL}
        trackClick="More about data & cloud security (footer)_Preset Managed Private Cloud"
        shadow
      >
        More about data & cloud security
      </Button>
    </Container>
  )
}

export default DataAndCloudSecuritySection
